import React, { Component } from 'react';

import { Container, Row, Col, ListGroup, ListGroupItem } from 'reactstrap';
import FooterMobile from '../footer-mobile/FooterMobile';
import SocialLinks from '../social-links/SocialLinks';
import FooterLinksBottom from '../footer-links-bottom/FooterLinksBottom';
import ScrollToTop from '../scroll-to-top/ScrollToTop';
import CookieBanner from '../cookie-banner/CookieBanner';
import VideoModal from '../video-modal/VideoModal';
import EirButton from '../eir-button/EirButton';
import { htmlWidget, LargeBusiness } from '../../Constants';

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videoModal: false,
      videoURL: "",
    };
  }
  // eir-1774 year script starts
  async componentDidMount() {
    var isIEBrowser = window.navigator.userAgent.indexOf("MSIE") > 0;
    if ($("#footer_date").length > 0) {
      $("#footer_date").html(new Date().getFullYear());
    }

    //for large business footer BGimage
    // {(LargeBusiness.isLBSite && this.props.footerBGImage != undefined && this.props.footerBGImage.length > 0)?
    //   document.documentElement.style.setProperty('--business-footer-bgImage' , this.props.footerBGImage):
    //   (!LargeBusiness.isLBSite && !isIEBrowser && this.props.siteTheme != undefined && this.props.siteTheme.length > 0)?
    //    document.documentElement.style.setProperty('--business-footer-theme', this.props.siteTheme):""}

    // change bg color of footer
    if (!isIEBrowser && this.props.siteTheme != undefined && this.props.siteTheme.length > 0) document.documentElement.style.setProperty('--business-footer-theme', this.props.siteTheme);
    //remove default style of the cookue button
    setTimeout(function () { document.querySelector("#ot-sdk-btn").style.cssText = ""; }, 2000);

    /*
  EIR-611 --- Video Modal to be popped up when it is beign included in paragraph or any other component
  Adding it here - as this has to be in a common react file which is being used throughout the application
  */
    let cookieButton = document.querySelector("#ot-sdk-btn");
    LargeBusiness.isLBSite && cookieButton && cookieButton.classList.add("eir-lb-square-edge");

    setTimeout(() => {
      // to get all the elements with the class trigger-video-modal
      var videoTag = document.querySelectorAll(".trigger-video-modal");
      if (videoTag != undefined && videoTag != null && videoTag.length > 0) {
        // setting url from each videotag to videoModal
        for (var i = 0; i <= videoTag.length; i++) {
          if (videoTag[i] != null || videoTag[i] != undefined) {
            var isBusinessSite = LargeBusiness.isLBSite || location.href.indexOf('/business/smb') > 0;

            if (!isBusinessSite) {
              var videoModal = document.querySelectorAll(".trigger-video-modal");
              videoModal[i].classList.add("trigger-video-modal-non-business-page");
            }
            // console.log("videotag", videoTag[i]);
            videoTag[i].addEventListener("click", (e) => {
              this.setState({ videoModal: false, videoURL: '' });
              // console.log(" >>", e.target.getAttribute("data-path"));
              this.setState({
                videoModal: true,
                videoURL: e.target.getAttribute("data-path"),
              });
            });
          }
        }
      }
    }, 2000);

    /*************************START***************************************************
      Check if current day is not a holiday and valid business hours - EIR-623
      The holidaylist.txt is available in openCMS in the path /json/holidaylist.txt
    **********************************************************************************/
    //convert time to seconds - EIR-623
    let isBusinessValid = false;
    const timeToSeconds = (time) => {
      var actualTime = time.split(':');
      var totalSeconds = (+actualTime[0]) * 60 * 60 + (+actualTime[1]) * 60 + (+actualTime[2]);
      return totalSeconds;
    }
    let holidayList, workingDays = [];
    let workStartHour, workEndHour = "";
    let getHolidayListWorkTimings = '/json/holidaylist.txt';
    !LargeBusiness.isLBSite ? (await fetch(getHolidayListWorkTimings)
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        holidayList = data.holidayList;
        workStartHour = data.workStartHour;
        workEndHour = data.workEndHour;
        workingDays = data.workingDays;
      })
      .catch((err) => {
        console.log("Error in fetching the holiday list - ", err);
      })) : console.info("")

    !LargeBusiness.isLBSite ? (setTimeout(() => {
      let currDate = new Date(),
        month = '' + (currDate.getMonth() + 1),
        date = '' + currDate.getDate(),
        year = currDate.getFullYear(),
        day = currDate.getDay(),
        hours = currDate.getUTCHours(),
        mins = currDate.getUTCMinutes(),
        secs = currDate.getUTCSeconds();
      if (month.length < 2) month = '0' + month;
      if (date.length < 2) date = '0' + date;
      let today = [date, month, year].join('-');
      let currTime = hours + ":" + mins + ":" + secs;
      let noHoliday = holidayList != undefined ? ((holidayList.indexOf(today) < 0) ? true : false) : false;
      let workingHrs = ((timeToSeconds(currTime) > timeToSeconds(workStartHour) && timeToSeconds(currTime) < timeToSeconds(workEndHour))) ? true : false;
      /*
      the json holds the workingday array as 1,2,3,4,5,6,7 -- (consider as monday, tuesday..., saturday, sunday)
      as the date function returns the day from 0-6 - so if sunday -it returns 0 and for our calculation if it is 0, treat it as 7
      */
      if (day == 0) day = 7;
      let weekDay = (workingDays.indexOf(day) > -1) ? true : false;
      if (noHoliday && weekDay && workingHrs) {
        isBusinessValid = true;
      }
      console.log("currTime is ", currTime + "\n workStartHour is ", workStartHour + "\n workEndHour is ", workEndHour + "\n && workingHrs is >> ", workingHrs + "\n workingDays -- are  ", workingDays + "\n today is ", day + "\n && weekday is >> ", workingDays.indexOf(day) + "\n isBusinessValid >>> ", isBusinessValid);
      localStorage.setItem("isBusinessValid", isBusinessValid);
    }, 2000)) : console.info("");
    /************************* END  ***************************************************/

  }
  //added as a part of videoModal
  toggleModel = () => {
    this.setState({
      videoModal: false,
    })
  }

  // eir-1774 year script ends
  render() {
    let footerClass = LargeBusiness.isLBSite ? "eir-lb-footer-BG" : "";

    return (
      <React.Fragment>
        {/* {this.props.script} */}
        <footer className={`footer ${footerClass}`} style={{ backgroundImage: `url(${this.props.footerBGImage})` }}>
          <Container className="footer-desktop">
            <Row>
              <ScrollToTop scrollBackToTop={this.scrollBackToTop} />
            </Row>
            <div className="eir-lb-footer-options">
              <Row className="business-lb-footer">
                {this.props.primaryNav.children.map((item, index) => {
                  return <Col key={index}>
                          <ListGroup className="footer-menu">
                              <ListGroupItem key={index} // className={((item.title.indexOf(" ") < 0)) ? "text-center footer-list list-first footer-title" : "footer-list list-first footer-title"}
                                  className="footer-list list-first footer-title">
                                  {/* {item.title}*/}
                                  {item.children.length < 1 ? <a href={item.link.link} title={item.title}>
                                          {item.title}
                                      </a> : <span className="no-link" role="heading" aria-level="2">
                                          {item.title}
                                      </span>}
                              </ListGroupItem>
                              {item.children.map((navItem, index) => {
                                  return <ListGroupItem key={index} className="footer-list">
                                          <EirButton {...navItem.link} className={'footer-links'} />
                                      </ListGroupItem>;
                              })}
                          </ListGroup>
                      </Col>;
                })}
              </Row>

            </div>
          </Container>
          <Container>
            <FooterMobile {...this.props} />
          </Container>
          <SocialLinks navItems={this.props.socialNav.children} />
          {/* added as part of business - footer changes - EIRZWM-501 */}
          {this.props.secondaryNav.children.length > 0 &&
            <Container>
              <Row>
                <Col>
                  <ul className="list-inline footer-links-bottom">
                    {this.props.secondaryNav.children.map((link, index) => {
                      return <FooterLinksBottom key={index} link={link.link} />;
                    })}
                  </ul>
                </Col>
              </Row>
            </Container>
          }
          <Container>
            <Row>
              <Col className={htmlWidget} md={{ size: 8, offset: 2 }} dangerouslySetInnerHTML={{ __html: this.props.disclaimer }} />
            </Row>
          </Container>
        </footer>
        {/* eir-1527 */}
        {/* <CookieBanner /> */}
        {/* Based on the videoModal - if true will trigger up the Video modal and load the respective video - EIR-611 */}
        {
          (this.state.videoModal) &&
          <VideoModal videoUrl={this.state.videoURL} videoPopup={this.state.videoModal} toggleVideoPopup={this.toggleModel}></VideoModal>
        }
      </React.Fragment>
    );
  }
}

export default Footer;
